var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
export var ListaArticulosTienda = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n"])));
export var ArticuloTiendaFoto = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: ", ";\n  padding: 0;\n  img {\n    width: 100%;\n    padding: 15px;\n    @media screen and (max-width: 1140px) {\n      padding: 10px;\n    }\n    @media screen and (max-width: 919px) {\n      padding: 5px;\n    }\n    @media screen and (max-width: 479px) {\n      padding: 0;\n    }\n    box-sizing: border-box;\n    display: flex;\n  }\n"], ["\n  width: ", ";\n  padding: 0;\n  img {\n    width: 100%;\n    padding: 15px;\n    @media screen and (max-width: 1140px) {\n      padding: 10px;\n    }\n    @media screen and (max-width: 919px) {\n      padding: 5px;\n    }\n    @media screen and (max-width: 479px) {\n      padding: 0;\n    }\n    box-sizing: border-box;\n    display: flex;\n  }\n"])), function (props) {
    return props.viewContext === "home"
        ? "calc(100% / 2)"
        : function () {
            switch (props.relevancia) {
                case 1:
                    return "calc(100% / 4)";
                case 2:
                    return "calc(100% / 3)";
                case 3:
                    return "calc(100% / 2)";
                default:
                    return "calc(100% / 2)";
            }
        };
});
var templateObject_1, templateObject_2;
